import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Button, Grid, Icon, Tab } from 'semantic-ui-react';
import transactions from '../../api/transactions';
import { defaultFromDate } from '../../config/dates';
import { getControlValues } from '../../helpers/summary';
import { setTransactionsKiosk } from '../../redux/actions';
import CompanyFilters from '../shared/CompanyFilters';
import DownloadButton from '../shared/DownloadButton';
import KioskTab from '../transactions/KioskTab';
import TicketsTab from '../transactions/TicketsTab';
import SummaryButton from '../shared/SummaryButton';

class TransactionsView extends React.Component {

  state = {
    loading: false,
    searchParams: {
      startDate: moment(defaultFromDate).toISOString(true),
      endDate: moment().toISOString(true),
      companyId: null,
      subCompanyId: null,
      siteId: null,
      includeEvents: false,
      sessionId: '',
      transactionRef: '',
      assetNo: '',
      playerId: null,
    },
    useCurrentDateTime: true,
    showSummary: true
  };

  setUseCurrentDateTime = () => this.setState({useCurrentDateTime: !this.state.useCurrentDateTime})
  
  componentDidUpdate(prevProps){
    if (this.props.filters.filterSelected.operator !== prevProps.filters.filterSelected.operator || this.props.filters.filterSelected.site.id !== prevProps.filters.filterSelected.site.id) {
      this.refreshSummary().then(() => this.handleRefresh());
    }
  }

  handleChange = (key, value, callback = () => { }) => this.setState({ searchParams: {...this.state.searchParams, [key]: value } }, callback);
    
  refreshSummary = async () => {
    const { filterSelected, filterData } = this.props.filters;
    const details = getControlValues(this.props.kiosk.summary.data);
    const { searchParams } = this.state;
    await transactions.getSummary(searchParams, filterSelected, filterData, details).then(
        summary => this.props.setTransactionsKiosk({ summary }).then(() => {
          this.setState({ loading: false })
        }),
        () => this.setState({ loading: false })
    );
  }

  refreshKiosk = (filterSelected, filterData, searchParams) => {
    this.setState({ loading: true }, () => {
      const details = getControlValues(this.props.kiosk.summary.data);
      transactions.getTransactions(searchParams, filterSelected, filterData, details, this.props.kiosk.grid.pageNumber).then(
        grid => this.props.setTransactionsKiosk({ grid }).then(() => this.setState({ loading: false, showSummary: true })),
        () => this.setState({ loading: false })
      );
    });
  }

  refreshTickets = (filterSelected, filterData, searchParams) => {
  
  }

  onOptionChange = (summary) => this.props.setTransactionsKiosk({ summary })

  handleRefresh = () => {
    const callback = () => {
      const { filterSelected, filterData } = this.props.filters;
      const { searchParams } = this.state;
      this.refreshKiosk(filterSelected, filterData, searchParams);
      this.refreshTickets(filterSelected, filterData, searchParams);
    }

    if (this.state.useCurrentDateTime) {
      this.handleChange("endDate", moment().toISOString(true), callback);
    } else {
      callback();
    }
  }

  onRefresh = () => this.refreshSummary().then(() => this.handleRefresh());

  render() {
    const showSummary = this.props.filters.filterSelected.site.id && this.state.showSummary

    const panes = [
      {
        key: "Kiosk/Cash Desk",
        menuItem: 'Kiosk/Cash Desk',
        pane: 
        <Tab.Pane><KioskTab showSummary={showSummary} onRefresh={this.handleRefresh} onOptionChange={this.onOptionChange} loading={this.state.loading} /></Tab.Pane>
      }
    ];

    if (this.props.kiosk.summary.optionShowTickets) {
      panes.push(
        {
          key: "Tickets",
          menuItem: 'Tickets',
          pane: <Tab.Pane><TicketsTab /></Tab.Pane>
        }
      )
    }

    return (
      <Grid className="height-100 gs-flex-container-vertical">
        <Grid.Row>
          <Grid.Column>
            <div className='flex-vertical' style={{ marginTop: "4px"}}>
              <div className='flex-shrink'>
                <div>
                  <SummaryButton
                    disabled={!this.props.filters.filterSelected.operator}
                    onClick={() => this.setState({ showSummary: !this.state.showSummary })}
                    active={this.state.showSummary}
                  />
                </div>
                <DownloadButton disabled={!this.props.filters.hasSelection} onClick={this.loadExport} />
              </div>
              <div className='flex-stretch ml-1'>
              <CompanyFilters
                {...this.state.searchParams}
                hasSelection={this.props.filters.hasSelection}
                useCurrentDateTime={this.state.useCurrentDateTime}
                setUseCurrentDateTime={this.setUseCurrentDateTime}
                onChange={this.handleChange}
                refresh={this.onRefresh}
                loading={this.state.loading}
              />
              </div>
         </div>
          </Grid.Column>
        </Grid.Row>        
        <Grid.Row className="flex-stretch">
          <Grid.Column width="16" className="gs-flex-container-vertical">
            <Tab renderActiveOnly={false} panes={panes} className="flex-stretch gs-flex-container-vertical mt-1 height-100" />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
};


const mapStateToProps = state => {
	return {
    filters: state.transactionsFilters,
    kiosk: state.transactionsKiosk
  };
};

export default connect(mapStateToProps, { setTransactionsKiosk })(TransactionsView);
